module.exports = __webpack_public_path__ + "img/arrow_solid_right.a6bec0e7.svg";